import { checkPrivacyTerms } from "@/utils/common";
import { dehydrate, QueryClient, useQuery } from "@tanstack/react-query";
import type { GetServerSideProps, NextPage } from "next";
import Seo from "@/components/common/Seo";
import { ESeoPage } from "@/utils/mockData/metaMocks";
import { getBrochureData, getNavBarData, getSeoInfo } from "@/utils/queries";
import { TPrivacyTermsPage } from "@/models/common/common";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { withRedirect } from "@/utils/redirects";
import PrivacyBody from "../../components/privacy/PrivacyBody";

const Privacy: NextPage<{
    checkedPathname: TPrivacyTermsPage;
    seoType: ESeoPage;
}> = ({ checkedPathname, seoType }) => {
    const { data: metaTags } = useQuery({
        queryKey: ["metaTags", seoType],
        queryFn: () => getSeoInfo(seoType),
    });
    const router = useRouter();

    useEffect(() => {
        router.push(checkedPathname);
    }, [checkedPathname]);

    return (
        <>
            <Seo seoInfo={metaTags!} />
            <PrivacyBody pathNameBody={checkedPathname} />
        </>
    );
};

export const getServerSideProps: GetServerSideProps = withRedirect(
    async ctx => {
        const checkedPathname = checkPrivacyTerms(ctx.query?.pathName);

        const id = process.env.NEXT_PUBLIC_IUBENDA_ID;

        if (!checkedPathname || !id) {
            return {
                notFound: true, // triggers 404
            };
        }

        const queryClient = new QueryClient();

        const seoType =
            checkedPathname === "privacy" ? ESeoPage.PRIVACY : ESeoPage.TERMS;

        await Promise.all([
            await queryClient.prefetchQuery(["navBar"], getNavBarData),
            await queryClient.prefetchQuery(["brochures"], getBrochureData),
        ]);

        return {
            props: {
                dehydratedState: dehydrate(queryClient),
                checkedPathname,
                seoType,
                id,
            },
        };
    }
);

export default Privacy;
